import { Award, Code, Shield, Users, Wrench, Zap } from 'lucide-react';

export const features = [
  {
    id: 1,
    icon: Award,
    title: 'Excelencia en Servicio',
    description:
      'Comprometidos con la calidad y satisfacción total de nuestros clientes en cada proyecto.',
  },
  {
    id: 2,
    icon: Shield,
    title: 'Seguridad Garantizada',
    description:
      'Implementamos las mejores prácticas de seguridad en todas nuestras soluciones tecnológicas.',
  },
  {
    id: 3,
    icon: Zap,
    title: 'Soluciones Ágiles',
    description: 'Respuesta rápida y eficiente a las necesidades cambiantes de tu negocio.',
  },
  {
    id: 4,
    icon: Wrench,
    title: 'Soporte Técnico 24/7',
    description:
      'Asistencia técnica continua para garantizar el funcionamiento óptimo de tus sistemas.',
  },
  {
    id: 5,
    icon: Users,
    title: 'Equipo Especializado',
    description:
      'Profesionales altamente capacitados con amplia experiencia en el sector tecnológico.',
  },
  {
    id: 6,
    icon: Code,
    title: 'Tecnología de Vanguardia',
    description:
      'Utilizamos las últimas tecnologías y metodologías para desarrollar soluciones innovadoras.',
  },
];
